import React, { useState } from 'react';
import { collection, getDocs, doc, setDoc } from '../firebase.config';

// Basic Backup & Restore for selected collections under artifacts/{appId}/users/{userId}
export default function BackupRestore({ db, userId, appId }) {
  const [message, setMessage] = useState('');
  const basePath = `artifacts/${appId}/users/${userId}`;

  const collectionsToBackup = [
    'items',
    'parties',
    'salesBills',
    'purchaseBills',
    'payments',
    'expenses',
    'companyDetails'
  ];

  const downloadJson = (data, filename) => {
    const blob = new Blob([JSON.stringify(data, null, 2)], { type: 'application/json' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = filename;
    a.click();
    URL.revokeObjectURL(url);
  };

  const handleBackup = async () => {
    try {
      setMessage('');
      const exportData = { meta: { userId, appId, exportedAt: new Date().toISOString(), basePath }, data: {} };
      for (const coll of collectionsToBackup) {
        const snap = await getDocs(collection(db, `${basePath}/${coll}`));
        exportData.data[coll] = [];
        snap.forEach(d => exportData.data[coll].push({ id: d.id, ...d.data() }));
      }
      downloadJson(exportData, `acctoo_backup_${appId}_${userId}_${Date.now()}.json`);
      setMessage('Backup exported.');
    } catch (e) {
      setMessage(e?.message || 'Backup failed');
    }
  };

  const handleRestore = async (evt) => {
    try {
      setMessage('');
      const file = evt.target.files?.[0];
      if (!file) return;
      const text = await file.text();
      const parsed = JSON.parse(text);
      const data = parsed?.data || {};
      let writes = 0;
      for (const coll of Object.keys(data)) {
        for (const docObj of data[coll]) {
          const id = docObj.id;
          const { id: _omit, ...payload } = docObj;
          await setDoc(doc(db, `${basePath}/${coll}`, id), payload, { merge: true });
          writes++;
        }
      }
      setMessage(`Restore completed. ${writes} records written.`);
      evt.target.value = '';
    } catch (e) {
      setMessage(e?.message || 'Restore failed');
    }
  };

  return (
    <div className="max-w-3xl mx-auto p-6">
      <h2 className="text-2xl font-bold text-gray-900 mb-4">Backup & Restore</h2>
      <p className="text-sm text-gray-600 mb-4">Export and import your basic company data (items, parties, bills, payments, expenses, company details). For safety, review backups before restoring.</p>

      <div className="flex flex-col sm:flex-row gap-3 mb-4">
        <button onClick={handleBackup} className="px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700">Download Backup (JSON)</button>
        <label className="px-4 py-2 bg-gray-100 text-gray-800 rounded cursor-pointer hover:bg-gray-200">
          Restore from JSON
          <input type="file" accept="application/json" onChange={handleRestore} className="hidden" />
        </label>
      </div>

      {message && <div className={`text-sm ${message.toLowerCase().includes('fail') ? 'text-red-600' : 'text-green-600'}`}>{message}</div>}

      <div className="mt-6 text-xs text-gray-500">
        <div>Scope: {basePath}</div>
        <div>Collections: {collectionsToBackup.join(', ')}</div>
      </div>
    </div>
  );
}


